import React, { useEffect, useState } from 'react'
import { useModal } from '../../../../hooks/useModal'
import { BotonProcesar } from '../../../components/buttons/BotonProcesar'
import { ContenedorParametros } from '../../../components/utils/ContenedorParametros'
import { useNeumaticos } from '../useNeumaticos'
import { Modal } from '../../../components/modal/Modal'
import { classNameInput, notify } from '../../../../utils/utils'
import imagenIncognito from '../../../../assets/images/iconoIncognito.png'

const MantenimientoNeumaticos = () => {
    const [codigoEstadoReintegro, setCodigoEstadoReintegro] = useState(0)
    const [codNeumaticoSeleccionado, setCodNeumaticoSeleccionado] = useState(0)
    const [nombreCodigoNeumaticoSelccionado, setNombreCodigoNeumaticoSeleccionado] = useState(0)
    const [isOpenModalReintegro, openModalReintegro, closeModalReintegro] = useModal()
    const [isOpenModalEliminar, openModalEliminar, closeModalEliminar] = useModal()
    const hookNeumaticos = useNeumaticos()

    useEffect(() => {
        hookNeumaticos.listarNeumaticoMantenimiento()
        hookNeumaticos.listarEstadosNeumaticos()
    },[])

    const registrarReintegro = async () => {
        if(codigoEstadoReintegro == 0){
            notify("Seleccionar un estado para el reintegro", 'error')
            return
        }
        const response = await hookNeumaticos.registrarReintegroNeumatico(codNeumaticoSeleccionado, codigoEstadoReintegro)
        notify(response.DesResultado, response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            closeModalReintegro()
            hookNeumaticos.listarNeumaticoMantenimiento()
        }
    }

    const eliminarNeumaticoReintegro = async () => {
        const response = await hookNeumaticos.eliminarNeumaticoReintegro(codNeumaticoSeleccionado)
        notify(response.DesResultado, response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            closeModalEliminar()
            hookNeumaticos.listarNeumaticoMantenimiento()
        }
    }

    return (
        <>
            <div className='flex flex-col gap-2 h-full'>
                <ContenedorParametros
                    titulo='Mantenimiento de neumáticos'
                    tablaId={'tablaMantenimiento'}
                >
                    <BotonProcesar onClick={hookNeumaticos.listarNeumaticoMantenimiento}></BotonProcesar>
                </ContenedorParametros>
                <div className='overflow-auto containerScroll'>
                    <table id='tablaMantenimiento' className='table'>
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>CÓDIGO</th>
                                <th>USUARIO</th>
                                <th>FECHA DESENLACE</th>
                                <th className='w-12'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                hookNeumaticos.listadoNeumaticosMantenimiento.length != 0 ?
                                    hookNeumaticos.listadoNeumaticosMantenimiento.map((data, i) => (
                                        <tr key={i+1}>
                                            <td>{i+1}</td>
                                            <td>{data.codigoNeumatico}</td>
                                            <td>{data.nomUsuario}</td>
                                            <td>{data.fechaDesenlace}</td>
                                            <td>
                                                <div className='flex gap-2'>
                                                    <button onClick={() => {
                                                        setCodNeumaticoSeleccionado(data.codNeumatico)
                                                        setNombreCodigoNeumaticoSeleccionado(data.codigoNeumatico)
                                                        setCodigoEstadoReintegro(0)
                                                        openModalReintegro()
                                                    }} className='btn btn-xs btn-primary'>Reintegrar</button>
                                                    <button onClick={() => {
                                                        setCodNeumaticoSeleccionado(data.codNeumatico)
                                                        setNombreCodigoNeumaticoSeleccionado(data.codigoNeumatico)
                                                        openModalEliminar()
                                                    }} title='Eliminar neumático' className='btn btn-xs btn-danger'><i className='fas fa-trash'></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                :
                                    <tr><td className='text-center' colspan="5">No hay información para mostrar...</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal 
                isOpen={isOpenModalReintegro}
                title={`Reintegrar neumático [${nombreCodigoNeumaticoSelccionado}]`}
                textButtons={{confirm: 'Aceptar', denied: 'Cancelar'}}
                action={registrarReintegro}
                closeModal={() => {
                    closeModalReintegro()
                }}
            >
                <div className='w-[400px] grid grid-cols-[auto_1fr] gap-4 items-center px-2 py-3'>
                    <span>Estado reintegro</span>
                    <select className={classNameInput} value={codigoEstadoReintegro} onChange={e => setCodigoEstadoReintegro(e.target.value)}>
                        <option value="0">--Seleccionar--</option>
                        {
                            hookNeumaticos.estados.map((data, i) => <option key={i+1} value={data.codNeumaticoEstado}>{data.nomNeumaticoEstado}</option>)
                        }
                    </select>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenModalEliminar}
                title={`Eliminar [${nombreCodigoNeumaticoSelccionado}]`}
                textButtons={{confirm: 'Aceptar', denied: 'Cancelar'}}
                action={eliminarNeumaticoReintegro}
                closeModal={closeModalEliminar}
            >
                <div className='w-[400px] flex gap-4 items-center justify-center'>
                    <img src={imagenIncognito} className='h-[100px]' alt="" />
                    <span className='font-bold'>Esta seguro de realizar la acción?</span>
                </div>
            </Modal>
        </>
    )
}

export default MantenimientoNeumaticos